<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import VatDeadlineForm from '@/components/vat-deadlines/VatDeadlineForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const form = useForm({
        period: '',
        settlement_period_from: null,
        settlement_period_to: null,
        deadline: null,
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.vat-deadlines.store')"
        :query-key="[QueryKey.VAT_DEADLINES]"
        title="system.add_vat_deadline"
        button-text="system.add_vat_deadline"
    >
        <VatDeadlineForm :form="form" />
    </DialogForm>
</template>
